import { useState } from "react";
import { Select, Textarea, Button, Stack } from "@mantine/core";
import { humanize } from "../../lib/labels";

// Reusable "change status with a comment" control for support tickets.
export function StatusUpdater({
  current,
  statuses,
  loading,
  onSubmit,
}: {
  current?: string;
  statuses: string[];
  loading: boolean;
  onSubmit: (status: string, comment: string) => void;
}) {
  const [status, setStatus] = useState(current ?? statuses[0]);
  const [comment, setComment] = useState("");

  const options = statuses.map((s) => ({ value: s, label: humanize(s) }));

  return (
    <Stack gap="xs">
      <Select
        label="Set status"
        data={options}
        value={status}
        onChange={(v) => setStatus(v ?? status)}
        allowDeselect={false}
      />
      <Textarea
        label="Comment"
        placeholder="What changed / resolution notes…"
        value={comment}
        onChange={(e) => setComment(e.currentTarget.value)}
        minRows={2}
        autosize
      />
      <Button
        loading={loading}
        disabled={!comment.trim()}
        onClick={() => onSubmit(status, comment.trim())}
      >
        Update status
      </Button>
    </Stack>
  );
}
